// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  usageId: __t.u64().primaryKey().name("usage_id"),
  workspaceId: __t.u64().name("workspace_id"),
  startedAt: __t.i64().name("started_at"),
  endedAt: __t.i64().name("ended_at"),
  minutes: __t.u32(),
  costUsdMicros: __t.i64().name("cost_usd_micros"),
  createdAt: __t.i64().name("created_at"),
});
